import React, { useState, useEffect } from "react";
import Header from "../../component/loaderComponent/Header/Header";
import Sidebar from "../Sidebar";
import './addrewardredeem.scss';
import { useNavigate } from "react-router-dom";
import { notify } from '../../services/notification';
import { postrewardredeemAction } from "../../actions/rewardAction";
import { useDispatch } from "react-redux";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import Validation from "../../constants/validation/Validation";
import { HiMenu, HiX } from "react-icons/hi";
import { MOBILE_BREAKPOINT, HTTP_STATUS } from "../../constants/constant";
import useMobileView from "../../constants/useMobileView";



function AddRewardRedeem() {
  const [states, setDataStates] = useState({
    product_code: "",
    product_description: "",
    points: ""
  });

  const [error, setError] = useState({
    product_code_error: "",
    product_description_error: ""
  })
  const [loading, setloading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isSidebarOpen, toggleSidebar } = useMobileView();



  const handlecancelbutton = () => {
    navigate("/rewardredeem")
  }





  const handleChange = (evt) => {
    const { name, value } = evt.target;

    setDataStates({
      ...states,
      [name]: value.replace(/^ +/gm, ""),
    });
  };

  const handleonsubmitclick = async () => {
    if (validateForm()) {
      if (parseInt(states.points) === 0) {
        setError({ points_error: "Reward Amount can not be zero" });
        return;
      }
      setloading(true);
      const apiReq = {
        product_code: states.product_code,
        product_description: states.product_description,
        points: states.points
      }
      let response = await dispatch(postrewardredeemAction(apiReq));
      if (response?.status === 200) {
        notify.success(response.data.messsge)
        setloading(false);
        navigate("/rewardredeem")
      } else if (response?.status === 400) {
        setloading(false);
      }
    }
  }


  let validateForm = () => {
    let formIsValid = true;
    if (states.product_code.length < 4) {
      setError({ product_code_error: "Wrong product code entered" });
      formIsValid = false;
    } else if (states.product_description.length < 5 || states.product_description.length > 20) {
      setError({ product_description_error: "Description should be between 5 and 20 characters" });
      formIsValid = false;
    } else if (parseInt(states.points) === 0) {
      setError({ points_error: "Reward Amount can not be zero" });
      formIsValid = false;
    } else {
      setError({});
    }
    return formIsValid;
  };

  return (
    <div className="add_rewardredeem_container">
      <div className="add_rewardredeem_conatiner">
        <Header title="Add Reward Amount" />
        {loading ? <Loader /> :
          <div className="add_reward_redeem_containers">
            <div className="add_reward_redeem_input_box_contain">
              <div className="add_reward_redeem">
                <label className="lable_add_reward_redeem">Coupon Variable</label>
                <input className="add_reward_redeem_input" type="text" placeholder="Coupon Variable" name="product_code" value={states.product_code} maxLength={4} minLength={4} onChange={handleChange} />
              </div>
              <div className="error-message-part-code">{error.product_code_error}</div>
              <div className="add_reward_redeem">
                <label className="lable_add_reward_redeem">Description</label>
                <input className="add_reward_redeem_input" type="text" placeholder="Description" name="product_description" maxLength={20} minLength={5} value={states.product_description} onChange={handleChange} />
              </div>
              <div className="error-message">{error.product_description_error}</div>
              <div className="add_reward_redeem">
                <label className="lable_add_reward_redeem">Reward Amount</label>
                <input className="add_reward_redeem_input" type="text" placeholder="Amount" name="points" value={states.points} onChange={handleChange} onKeyPress={(e) => Validation.numberinputValidator(e)} />
              </div>
              <div className="error-message">{error.points_error}</div>
              <div className="add_reward_redeem_button">
                <button className="add_reward_redeem_submit_button"
                  onClick={handleonsubmitclick}
                  disabled={
                    states.product_code == "" ||
                    states.product_description == "" ||
                    states.points == ""
                  }
                >Submit</button>
                <button className="Add-rewards-cancel-button" onClick={handlecancelbutton}>Cancel</button>
              </div>
            </div>
          </div>}
      </div>
    </div>
  )
}
export default AddRewardRedeem;;